// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-flex.justify-content-center[data-v-28bc0320]{align-items:center}.d-flex.justify-content-center .spinner-border.spinner-border-xl[data-v-28bc0320]{width:5rem;height:5rem;border-width:.4rem}.d-flex.justify-content-center .loading-text[data-v-28bc0320]{margin-left:8px}", ""]);
// Exports
module.exports = exports;
